import { ReactNode } from 'react';
import { NSCard } from 'bricks';
import { CardBody, CardHeader, Col, Row } from 'reactstrap';
import ExecutiveSummaryDetail from '../ExecutiveSummaryDetail/ExecutiveSummaryDetail';
import ExecutiveSummaryGenericTable from '../ExecutiveSummaryGenericTable/ExecutiveSummaryGenericTable';
import { MapPoint, OperationsTitle, SummaryBlocks } from '../types';

export interface ExecutiveSummaryContentProps {
    subtitle: string;
    blocks: SummaryBlocks;
    map: MapPoint | null;
    timeline?: ReactNode;
    headerAction?: ReactNode;
    operationsTitle?: OperationsTitle;
    showCents?: boolean;
}

const ExecutiveSummaryContent = ({
    subtitle, blocks, map, timeline, headerAction, operationsTitle = 'OPERATIONS', showCents,
}: ExecutiveSummaryContentProps) => (
    <NSCard className="NSCard--level-2 shadow-none">
        <CardHeader>
            <div className="d-flex align-items-center justify-content-between text-white">
                <div className="d-flex align-items-center">
                    <div>
                        <h4 className="mb-0">Executive Summary</h4>
                        <h5 className="mb-1 mt-1 text-muted">{subtitle}</h5>
                    </div>
                </div>
                {headerAction && <div>{headerAction}</div>}
            </div>
        </CardHeader>
        <CardBody>
            <ExecutiveSummaryDetail sections={blocks.details} map={map} />
            {timeline}
            <Row className="mx-n1">
                <Col className="px-1 mb-2" sm={12} md={5}>
                    <ExecutiveSummaryGenericTable title="ASSUMPTIONS" sections={blocks.assumptions} fixedHeight showCents={showCents} />
                </Col>
                <Col className="px-1 mb-2" sm={12} md={7}>
                    <ExecutiveSummaryGenericTable
                        title="FORECAST"
                        sections={blocks.forecast}
                        rowClassName="py-1"
                        fixedHeight
                        showCents={showCents}
                    />
                </Col>
            </Row>
            <div>
                <ExecutiveSummaryGenericTable title="RETURNS" sections={blocks.returns} showCents={showCents} />
                <div className="mb-2" />
                <ExecutiveSummaryGenericTable title="DEVELOPMENT" sections={blocks.development} showCents={showCents} />
                <div className="mb-2" />
                <ExecutiveSummaryGenericTable title={operationsTitle} sections={blocks.operations} showCents={showCents} />
            </div>
        </CardBody>
    </NSCard>
);

export default ExecutiveSummaryContent;
